import { api } from './api';
export const aiApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // AI创作辅助
        getAIAssist: builder.mutation({
            query: (data) => ({
                url: '/ai/assist',
                method: 'POST',
                body: data,
            }),
        }),
        // AI续写
        continueWriting: builder.mutation({
            query: (data) => ({
                url: '/ai/continue',
                method: 'POST',
                body: data,
            }),
        }),
        // AI改写
        rewriteText: builder.mutation({
            query: (data) => ({
                url: '/ai/rewrite',
                method: 'POST',
                body: data,
            }),
        }),
        // AI对话生成
        generateDialogue: builder.mutation({
            query: (data) => ({
                url: '/ai/dialogue',
                method: 'POST',
                body: data,
            }),
        }),
        // AI生成图片
        generateImage: builder.mutation({
            query: (data) => ({
                url: '/ai/generate-image',
                method: 'POST',
                body: data,
            }),
        }),
        // AI生成场景图片
        generateSceneImage: builder.mutation({
            query: (data) => ({
                url: '/ai/generate-scene-image',
                method: 'POST',
                body: data,
            }),
        }),
    }),
});
export const { useGetAIAssistMutation, useContinueWritingMutation, useRewriteTextMutation, useGenerateDialogueMutation, useGenerateImageMutation, useGenerateSceneImageMutation, } = aiApi;
